export default __webpack_public_path__ + "static/media/taborak_barva-min.335337e6.png";